import { errorHandler } from 'atoms/utils';

const logError = (error) => errorHandler(error, null);

export default logError;
